<template>
  <div class="sfsdrrwer">
    <div></div>
    
    <van-dialog v-model="showNotice" :showConfirmButton="false" :overlay="false">
      <div class="pt10 pm10 pr cen cf" style="background-color: #a9716d">
        <span class="cz ml10 fz17">提 示</span>
      </div>
      <div class="newDiv">
        <div class="content">
          <div v-if="redirectPageDiscript">{{ redirectPageDiscript }}</div>
        </div>
      </div>
      <div class="pt10 pm10 btm cen">
        <!-- <van-button
          type="primary"
          class="w40"
          :loading="loading"
          @click="toHome"
          >返回首页</van-button
        >&nbsp;&nbsp;&nbsp;&nbsp; -->
        <van-button
          type="primary"
          class="w40"
          :loading="loading"
          @click="redirectPage"
          >立即前往</van-button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import memberService from "@/services/memberService.js";

export default {
  name: "redirectPage",
  computed: {
    contentHeight() {
      return document.documentElement.clientHeight;
    },
    ...mapState({
      options: (state) => state.orderModule.options,
      member: (state) => state.memberModule.member,
    }),
  },
  data() {
    return {
      redirectUrl: "",
      redirectPageDiscript: "",
      showNotice: false,
      loading: false,
    };
  },
  async created() {
    var redirectUrl = this.$route.query.redirectUrl;
    var redirectPageDiscript = this.$route.query.redirectPageDiscript;
    // console.log(redirectUrl);
    // console.log(redirectPageDiscript);
    if (redirectUrl) {
      this.redirectUrl=decodeURIComponent(redirectUrl);
      if(redirectPageDiscript){
        this.redirectPageDiscript=decodeURIComponent(redirectPageDiscript);
      } else {
        this.redirectPageDiscript="";
      }
      this.showNotice = true;
    }
  },
  methods: {
    ...mapActions("memberModule", [appConsts.loadMemberAsync]),
    async redirectPage() {
      this.loading = true;
      try {
        let loginUrl = await memberService.getLoginUrl(this.redirectUrl);
        window.location.href = loginUrl;
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    toHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  background-color: rgb(124, 124, 124);
  width: 50px;
  height: 50px;
  border-radius: 5%;
}
.sfsdrrwer {
  height: calc(100vh);
  background: url("../assets/img/indexbg.jpg");
  background-size: 100%;
}
.content {
  margin-top: 20px;
  padding: 0 10px;
  padding-bottom: 20px;
  background-color: white;
  /* min-height: calc(100vh - 10px); */
}
.newDiv {
  max-height: calc(50vh);
  overflow-y: auto;
}
</style>

